module.exports = __webpack_public_path__ + "img/pdf_icon.cbd79721.png";